<template>
  <div>
    <h6 class="ml-4 pt-2">Multi Load Haul</h6>
    <div class="details-container ml-4 pl-4" v-for="(load, index) in loads" :key="index">
      <div class="item location py-2">
        <h6>Load Location</h6>
        <p>{{load.load_location}}</p>
      </div>
      <div class="item ticket py-2">
        <h6>Truck Ticket</h6>
        <p>{{load.truck_ticket}}</p>
      </div>
      <div class="item date py-2">
        <h6>Start Date/Time</h6>
        <p>{{load.load_start_datetime}}</p>
      </div>
      <div class="item volume py-2">
        <h6>Est. Vol</h6>
        <p>{{load.volume_estimate}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    loads: {
      type: Array,
      default: []
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/hauls/rowDetails.vue